import React, { useEffect, useState, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Modal } from 'react-bootstrap';
import { getIlustrationSignature, getSelfie } from '../../store/features/CameraAndSignatureSlice'
import styles from './SpajDetailPage.module.css'
import Header from '../../component/Header/header';
import ProgressBar from '../../component/ProgressBar/progressbar';
import { StatusCustomer } from '../../component/Helper'
import { updateStatusSpaj, updateStatusCustomer } from '../../store/features/SPAJSlice';
import SinglePagePDFViewer from "../../component/customPdf/single-page";
import AllPagesPDFViewer from "../../component/customPdf/all-pages";
import Spinners from '../../component/Spinner/spinners';
import LockScreen from '../../component/LockScreen/lockscreen';
import cookie from 'js-cookie'

export default function LandingPage() {
    let dispatch = useDispatch()
    let navigate = useNavigate()
    let [showHide, setShowHide] = useState(false)
    let [showNotifRev, setshowNotifRev] = useState(false)
    let [revisiCount, setRevisiCount] = useState(false)
    const { Ilustration } = useSelector((state) => state.Ilustration)
    const { SPAJDetail } = useSelector((state) => state.SPAJsDetail)
    const { DeviceId } = useSelector((state) => state.DeviceId)
    const [statusCustomer, setStatusCustomer] = useState("");
    const [isUnitLink, setIsUnitLink] = useState(0);
    const { SPAJs } = useSelector((state) => state.SPAJs);
    const { Parameter } = useSelector((state) => state.Params);
    const userAgent = navigator.userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
    let [loading, setLoading] = useState(false)
    const [numPages, setNumPages] = useState(0);
    const [lastPage, setLastPage] = useState(false);
    const [buttonRevisi, setButtonRevisi] = useState(true);
    useEffect(() => {
            setStatusCustomer(StatusCustomer(SPAJs.spajHeader.statusCustomer,SPAJs.spajHeader?.isUnitLink));
            setIsUnitLink(SPAJs.spajHeader?.isUnitLink);
    }, [SPAJs])
 
    // useEffect(()=>{
    //     let revisiParams = Parameter.dataParameterApps.find(item=>{
    //         // MAX_REVISI
    //         if (item.codeSetting == "MAX_REVISI"){
    //             if(item.valueSetting <= SPAJs.spajHeader.countRevisi){
    //                 setButtonRevisi(false)
    //             }
    //         }
    //     })
    // },[])

    // useEffect(() => {
    //     setLoading(true)

    //     let dataIllustration = {
    //         deviceId: `${DeviceId.deviceId}`,
    //         userName: `${SPAJDetail.dataSpaj.email}`,
    //         spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`
    //     }
    //     dispatch(getIllustrationSPAJ(dataIllustration)).then(res => {
    //         setLoading(false)
    //         s(true)
    //     }).catch(err => {
    //         setLoading(false)
    //     })
    // }, [])


    useEffect(() => {
        let maxRevisi = Parameter.dataParameterApps.find(row => row.codeSetting == "MAX_REVISI").valueSetting;
        let countRevisi = SPAJs.spajHeader.countRevisi

        if (parseInt(countRevisi) >= parseInt(maxRevisi)) {
            setButtonRevisi(false);
        }
    }, [Parameter, SPAJs])

    useEffect(() => {
        if (statusCustomer > 2) {
            setLastPage(true)
            setButtonRevisi(false);
        }
    }, [statusCustomer])

    const listInnerRef = useRef();

    const goToPersetujuan = () => {
        setLoading(true)

        // let data = {
        //     deviceId: `${DeviceId.deviceId}`,
        //     userName: `${SPAJDetail.dataSpaj.email}`,
        //     spajNumber: `${SPAJDetail.dataSpaj.spajNumber}`,
        //     apps: "sys"
        // }
        // dispatch(getIlustrationSignature(data))
        // dispatch(getSelfie(data))
        nextPage();
        setLoading(false)
        navigate('/form-final-step')
    }

    const showTerms = (e) => {
        if (statusCustomer == 2) {
            setShowHide(true)
        }
    }
    const hideTerms = (e) => {
        setShowHide(false)
    }

    const revisiData = () => {
        setShowHide(false)
        setshowNotifRev(true)
    }

    const revData = () => {
        setLoading(true)
        setshowNotifRev(false)
        let detailData = {
            deviceId: `${DeviceId.deviceId}`,
            userName: `${SPAJs.spajHeader?.userName}`,
            spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
            agentStatus: "D",
            customerStatus: "RJC"
        }
        dispatch(updateStatusSpaj(detailData)).then(res => {
            // UPDATE LOCAL STATUS CUSTOMER KE RJC
            dispatch(updateStatusCustomer("RJC"));
            cookie.remove('accessToken');
            cookie.remove('refreshToken');
            localStorage.removeItem("SPAJ_HEADER");
            localStorage.removeItem("TOKEN");
            sessionStorage.removeItem('tokenPayment');
            setLoading(false)
            navigate("/" + localStorage.getItem("spajHash"));
        })
    }

    const nextPage = () => {
        if (statusCustomer == 2) {
            let detailData = {
                deviceId: `${DeviceId.deviceId}`,
                userName: `${SPAJs.spajHeader?.userName}`,
                spajNumber: `${SPAJs.spajHeader?.spajNumber}`,
                agentStatus: "IPC",
                customerStatus: "CS"
            }
            dispatch(updateStatusSpaj(detailData)).then(res => {
                // UPDATE LOCAL STATUS CUSTOMER KE CS
                dispatch(updateStatusCustomer("CS"));
            })
        }
    }

    const onDocumentLoadSuccess = doc => {
        setNumPages(doc._pdfInfo.numPages)
        setLastPage(true)
    }

    const endPage = () => {
        setLastPage(true)
    }

    const scroll = () => {
        if (listInnerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
            if (Math.ceil(scrollTop + clientHeight) >= scrollHeight - 5) {
                setLastPage(true)
            }
        }
    }

    return (
        <>
            {statusCustomer < 2 &&<LockScreen/>}
            {loading == true && <Spinners />}
            <div>
                <Header />
                <div className="g-0 welcome-container">
                    <div className={`position-relative ${styles.bgContainer}`}>
                    <ProgressBar step="2" status={statusCustomer} isUnitlink={isUnitLink}/>
                    <div style={{width:'100%', height:'100%', overflowX: 'auto'}} ref={listInnerRef}>
                        <div className={styles.allCardGreySPAJ}>
                            <div className={styles.cardContainer}>
                                    <div style={{ width: '100%', height: '100%',overflowX: 'auto'}} ref={listInnerRef} onScroll={scroll}>
                                        {/* <embed src={`data:application/pdf;base64,${Ilustration.b64Spaj}`} width="100%" height="100%" /> */}
                                        <AllPagesPDFViewer pdf={`data:application/pdf;base64,${Ilustration?.b64Spaj}`} onLoadSuccess={onDocumentLoadSuccess} onEndPage={() => endPage()} />
                                    </div>
                                <div className={styles.posbuttonFloatingUp}>
                                    <button className={styles.buttonFloatingUp} onClick={() => { listInnerRef.current.scrollTo(-100, -100); window.scrollTo(-100, -100); }} ><img src="images/up-arrow.png" width="20" /></button>
                                </div>
                               
                                <div className={`position-relative`} style={{height: 150,marginBottom: 30,marginTop: 30}}>
                                    <div className={styles.containerbottompdf}>
                                        <div style={{width:'65%'}} className={styles.wordingContainer}>
                                            <div className={styles.changeText}>Jika tidak ada perubahan data, silakan klik tombol "Selanjutnya"</div>
                                            {/* <button onClick={() => navigate('/finalstep')}>finalstep</button> */}
                                        </div>
                                        <div style={{width:'35%'}} onClick={showTerms}>
                                            <button className={buttonRevisi ? styles.buttonnrevisi : styles.buttonnrevisiDisable} disabled={!buttonRevisi}>
                                                Permintaan Perubahan Data
                                            </button>
                                        </div>
                                    </div>
                                    <div className={styles.pbotton}>
                                        <div style={{ display: 'flex' }}>
                                            <div>
                                                <button className={styles.buttonkembali} onClick={() => navigate('/ilustrasi')}>Kembali</button>
                                            </div>
                                            <div>
                                                <button className={styles.buttonnext} onClick={() => goToPersetujuan()}>Selanjutnya</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        </div>
                         <div className={styles.linkFooter}>
                            <div>www.generali.co.id</div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal dialogClassName={styles.modalcustom} centered show={showHide}>
                <Modal.Body>
                    <div className='mt-40'>
                        <p className='fs-15 text-center'>Apakah Anda yakin ingin melakukan perubahan data?</p>
                        <div className='btnmodal'>
                            <div style={{ display: 'flex', justifyContent: 'flex-end' }} >
                                <button className={styles.buttonkembalimodal} onClick={() => revisiData()}>
                                    Ya
                                </button>
                                <button className={styles.buttonnextmodal} onClick={() => hideTerms()}>
                                    Tidak
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>



            <Modal dialogClassName={styles.modalcustom} centered show={showNotifRev}>
                <Modal.Body>
                    <div className={styles.containerModal}>
                        <p className='fs-15 text-center mb-25'>Silakan menghubungi Agen Anda untuk perubahan data SPAJ Anda.</p>
                        <div onClick={() => revData()}>
                            <div>
                                <button className={styles.buttonnextmodal}>
                                    OK
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
        // <div>
        //   <h1>Selamat Datang! {SPAJDetail.dataSpaj?.fullName} SPAJ {SPAJDetail.dataSpaj?.spajNumber}</h1>
        //   <button onClick={(e)=>goOut(e)}>logOut</button>
        // </div>
    )
}

